import {BaseService} from './Core/BaseService';

class ProgramBenefitStatisticService extends BaseService {
    get Url() { return super.Url + "/programBenefitStatistics"; }

    GetProgramBenefitStats(programId, environmentalBenefitId, conservationActionPhaseId, confirmationStatusId = null) {
        let request = {
            programId: programId,
            environmentalBenefitId: environmentalBenefitId,
            conservationActionPhaseId: conservationActionPhaseId,
            confirmationStatusId: confirmationStatusId
        };

        return this.SendRequest(BaseService.GET, request);
    }
}

export const service = new ProgramBenefitStatisticService();

